import { create } from 'zustand'

type UseSidebarType = {
  isShow: boolean
  firstRender: boolean // Optional, used for initial render state

  showSidebar: () => void
  hideSidebar: () => void
  toggleSidebar: () => void
  setFristRender: (firstRender: boolean) => void
}

export const useSidebar = create<UseSidebarType>((set) => ({
  isShow: true,
  firstRender: true,

  showSidebar: () => set({ isShow: true }),
  hideSidebar: () => set({ isShow: false }),
  toggleSidebar: () => set((pre) => ({ isShow: !pre.isShow })),
  setFristRender: (firstRender) => set({ firstRender }),
}))
